/**
 * File Type Selector Component
 * Toggle between Excel and JSON file import types
 */

import { FileSpreadsheet, FileJson } from 'lucide-react';
import { ToggleGroup, ToggleGroupItem } from '@/core/components/ui/toggle-group';
import { Label } from '@/core/components/ui/label';
import { ImportFileType, ImportFileTypeLabels } from '../../types/translation-types';

interface FileTypeSelectorProps {
  value: ImportFileType;
  onChange: (value: ImportFileType) => void;
  disabled?: boolean;
  className?: string;
}

export function FileTypeSelector({
  value,
  onChange,
  disabled = false,
  className = '',
}: FileTypeSelectorProps) {
  return (
    <div className={`space-y-2 ${className}`}>
      <Label>File Type</Label>
      <ToggleGroup
        type="single"
        value={value}
        onValueChange={(val) => val && onChange(val as ImportFileType)}
        disabled={disabled}
        className="justify-start"
      >
        <ToggleGroupItem
          value={ImportFileType.Excel}
          aria-label="Excel file"
          className="flex items-center gap-2 px-4"
        >
          <FileSpreadsheet className="h-4 w-4" />
          {ImportFileTypeLabels[ImportFileType.Excel]}
        </ToggleGroupItem>
        <ToggleGroupItem
          value={ImportFileType.Json}
          aria-label="JSON file"
          className="flex items-center gap-2 px-4"
        >
          <FileJson className="h-4 w-4" />
          {ImportFileTypeLabels[ImportFileType.Json]}
        </ToggleGroupItem>
      </ToggleGroup>
    </div>
  );
}
